import { render, staticRenderFns } from "./estatecuredbrokerfiledetails.vue?vue&type=template&id=5db12746"
import script from "./estatecuredbrokerfiledetails.vue?vue&type=script&lang=js"
export * from "./estatecuredbrokerfiledetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports